import type { RouteRecordRaw } from 'vue-router'
import { kycRoutes } from './kyc/kycRoute'
import { kyaRoutes } from './kya/kyaRoute'
import { riskProfilingRoutes } from './riskProfiling/riskProfilingRoute'
import { sourceOfFundsRoutes } from './sourceOfFunds/sourceOfFundsRoute'
import { auditLogsRoutes } from './auditLogs/auditLogsRoute'

export const complianceRoutes: RouteRecordRaw[] = [
  ...kycRoutes,
  ...kyaRoutes,
  ...riskProfilingRoutes,
  ...sourceOfFundsRoutes,
  ...auditLogsRoutes,
]
